import Carousel from "react-multi-carousel";
import Footer from "../components/footer";
import Header, { HeaderContext } from "../components/header";
import { INTERNATIONAL, responsive } from "../components/utils";
import "react-multi-carousel/lib/styles.css";
import Info from "../components/info";
import { useContext, useEffect, useState } from "react";
import getPromos from "../providers/promos";
import { button_text, home_text, international_text } from "../translation";
import { Helmet } from "react-helmet";

export default function International() {
	const { lang } = useContext(HeaderContext);

	const [promos, setPromos] = useState([]);

	const fetchPromos = async () => {
		try {
			const promosData = await getPromos(INTERNATIONAL);
			setPromos(promosData);
		} catch (error) {
			console.error("Failed to fetch promos:", error);
		}
	};

	const url = 'https://www.dosgardeniastours.com/vuelos-internacionales';

	useEffect(() => {
		fetchPromos();
	}, []);
	// const onPromoClick = (item) => {
	// 	setItem(item);
	// 	setOpenInfo(true);
	// };
	return (
		<div>
			<Header />
			<Helmet>
				<title>Vuelos internacionales Dos Gardenias Tours </title>
                <link rel="canonical" href={url} />                
                <meta name="description" content={'Busca tu viaje internacional soñado a los lugares más turísticos del mundo'} />
                <meta property="og:site_name" content="DosGardeniasTours" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={url} />
                <meta property="og:title" content='Vuelos internacionales Dos Gardenias Tours' />
                <meta property="og:description" content={'Prepara lo mejor para tu viaje internacional a los lugares más turísticos del mundo'} />    
			</Helmet>
			<div>
				<div className="bg-dggray-200">
					<img
						className="hidden md:block"
						alt="promo-image"
						src={`/images/international/head_web_[${lang}].png`}
					/>
					<img
						className="block md:hidden"
						alt="promo-image"
						src={`/images/international/head_mobile_[${lang}].png`}
					/>
					<div className="px-4 md:px-32 font-poppins ">
						<p className="text-3xl md:text-5xl my-14 text-center text-dgtitle font-ivymode">
							{home_text.promos[lang]}
						</p>
						<Carousel
							infinite
							responsive={responsive}
							autoPlay
							arrows={true}
						>
							{promos.map((it, idx) => (
								<a
									target="_blank"
									rel="noreferrer"
									href={it.pdf}

									key={"key-" + idx}
									className="hover:cursor-pointer hover:shadow-lg"
									// onClick={() => onPromoClick(it)}
								>
									<img
										alt="promo-image"
										src={it.img}
										className="m-auto h-40 md:h-auto md:max-h-fit px-2"
									/>
									<p className="text-md md:text-2xl font-poppins text-center mt-4">
										{it.name}
									</p>
								</a>
							))}
						</Carousel>
						<Info
							title={international_text.ques[lang]}
							subtitle={international_text.sub_ques[lang]}
							button_txt={button_text.coti[lang]}
							bg={"bg-dggray-200"}
							title_color={"text-dgtitle"}
							subtitle_color={"text-gray-400"}
						/>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}
